/** @jsx jsx */
import * as React from 'react';
import { jsx } from '@balance-web/core';
import { Flex } from '@balance-web/flex';
import { Text } from '@balance-web/text';
import { useTheme } from '@balance-web/theme';

import { PageBlock } from '../../generic/PageBlock';

export type SiteHeaderProps = {
  logo: React.ReactNode;
  siteName?: string;
  user?: React.ReactNode;
  navigation?: React.ReactNode;
};

export const SiteHeader = ({
  siteName,
  logo,
  user,
  navigation,
}: SiteHeaderProps) => {
  const { semantic } = useTheme();

  return (
    <Flex
      alignItems="center"
      background="base"
      css={{
        borderBottom: `1px solid ${semantic.colour.surface.neutral.border}`,
      }}
      height="64px"
      paddingLeft="xxlarge"
      paddingRight="xlarge"
    >
      <PageBlock direction="row" size={['small', 'large', 'xlarge']}>
        <Flex alignItems="center" gap="small" marginRight="xxlarge">
          {logo}
          {siteName && (
            <Text size="large" weight="bold">
              {siteName}
            </Text>
          )}
        </Flex>
        <Flex
          alignItems="center"
          flexGrow={1}
          height="100%"
          justifyContent="space-between"
        >
          {navigation}
          {user && (
            <Flex flexGrow={1} justifyContent="flex-end">
              {user}
            </Flex>
          )}
        </Flex>
      </PageBlock>
    </Flex>
  );
};
